import React from 'react';
import { Box } from 'theme-ui';

const FlexImage = ({
  children,
  flexBasis = [null, '2/3', null, '1/2'],
  order,
  sx,
}) => (
  <Box
    sx={{
      flexBasis,
      // zIndex: [null, -1],
      position: 'relative',
      order,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default FlexImage;
